import React from 'react';

export default function IdentityScreen({ firstName, lastName, email, setFirstName, setLastName, setEmail, onContinue, onBack, isLoading }) {
  const isValid = firstName.trim() && lastName.trim() && email.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  return (
    <div className="view on" data-testid="identity-screen">
      <h1>About You</h1>
      <p className="desc">We need a few details to personalise your report.</p>

      <div className="input-group">
        <div className="label teal">Full Name</div>
        <div className="input-row">
          <input
            type="text"
            className="input-field"
            placeholder="First Name"
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
            data-testid="first-name-input"
          />
          <input
            type="text"
            className="input-field"
            placeholder="Last Name"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
            data-testid="last-name-input"
          />
        </div>
      </div>

      <div className="input-group">
        <div className="label teal">Email Address</div>
        <input
          type="email"
          className="input-field"
          placeholder="you@company.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          data-testid="email-input"
        />
      </div>

      <button
        className="btn btn-p"
        onClick={onContinue}
        disabled={!isValid || isLoading}
        data-testid="identity-continue-btn"
      >
        {isLoading ? 'Checking...' : 'Continue'}
      </button>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
        <button className="text-link" onClick={onBack} data-testid="identity-back-btn">&larr; Back</button>
      </div>
    </div>
  );
}
